// 採購訂單系統資料模型
// Purchase Order System Data Model

import { suppliers as importedSuppliers, products } from './inventoryData';
import { mrpPlans, purchaseSuggestions } from './mrpData';

// Re-export suppliers from inventoryData
export const suppliers = importedSuppliers;

// 採購訂單狀態
export const purchaseOrderStatuses = [
  {
    id: 'draft',
    name: '草稿',
    name_en: 'Draft',
    color: '#9CA3AF',
    icon: 'FileText'
  },
  {
    id: 'pending_approval',
    name: '待核准',
    name_en: 'Pending Approval',
    color: '#F59E0B',
    icon: 'Clock'
  },
  {
    id: 'approved',
    name: '已核准',
    name_en: 'Approved',
    color: '#10B981',
    icon: 'CheckCircle'
  },
  {
    id: 'sent',
    name: '已發送',
    name_en: 'Sent',
    color: '#3B82F6',
    icon: 'Send'
  },
  {
    id: 'partially_received',
    name: '部分收貨',
    name_en: 'Partially Received',
    color: '#8B5CF6',
    icon: 'TruckLoading'
  },
  {
    id: 'received',
    name: '已收貨',
    name_en: 'Received',
    color: '#059669',
    icon: 'Package'
  },
  {
    id: 'cancelled',
    name: '已取消',
    name_en: 'Cancelled',
    color: '#EF4444',
    icon: 'XCircle'
  },
  {
    id: 'closed',
    name: '已結案',
    name_en: 'Closed',
    color: '#6B7280',
    icon: 'Archive'
  }
];

// 付款條件
export const paymentTerms = [
  {
    id: 'net30',
    name: '月結30天',
    name_en: 'Net 30',
    days: 30
  },
  {
    id: 'net60',
    name: '月結60天',
    name_en: 'Net 60',
    days: 60
  },
  {
    id: 'cod',
    name: '貨到付款',
    name_en: 'Cash on Delivery',
    days: 0
  },
  {
    id: 'prepaid',
    name: '預付款',
    name_en: 'Prepaid',
    days: -1
  },
  {
    id: 'net15',
    name: '月結15天',
    name_en: 'Net 15',
    days: 15
  },
  {
    id: 'net45',
    name: '月結45天',
    name_en: 'Net 45',
    days: 45
  },
  {
    id: 'net90',
    name: '月結90天',
    name_en: 'Net 90',
    days: 90
  }
];

// 運送方式
export const shippingMethods = [
  {
    id: 'standard',
    name: '標準運送',
    name_en: 'Standard Shipping',
    days: 5,
    cost: 500
  },
  {
    id: 'express',
    name: '快速運送',
    name_en: 'Express Shipping',
    days: 2,
    cost: 1200
  },
  {
    id: 'pickup',
    name: '自取',
    name_en: 'Self Pickup',
    days: 0,
    cost: 0
  },
  {
    id: 'supplier_delivery',
    name: '供應商送貨',
    name_en: 'Supplier Delivery',
    days: 3,
    cost: 300
  }
];

// 採購訂單
export const purchaseOrders = [
  {
    id: 'po-2025-001',
    po_number: 'PO-2025-001',
    supplier_id: 'sup-001',
    status: 'approved',
    created_at: '2025-01-05T09:30:00',
    created_by: '王採購',
    approved_at: '2025-01-06T14:20:00',
    approved_by: '張經理',
    order_date: '2025-01-06',
    expected_delivery_date: '2025-01-20',
    payment_term_id: 'net30',
    shipping_method_id: 'standard',
    shipping_address: '台北市信義區信義路五段7號',
    subtotal: 150000,
    tax: 7500,
    shipping_cost: 500,
    total: 158000,
    currency: 'TWD',
    notes: '依MRP計劃採購原料',
    mrp_plan_id: 'mrp-2025-q1',
    related_suggestion_ids: ['ps-001'],
    items: [
      {
        id: 'po-item-001',
        po_id: 'po-2025-001',
        product_id: 'prod-001',
        description: '鋁合金材料 A-grade',
        quantity: 3000,
        unit: '公斤',
        unit_price: 50,
        subtotal: 150000,
        expected_delivery_date: '2025-01-20',
        received_quantity: 0,
        remaining_quantity: 3000
      }
    ],
    attachments: [
      {
        id: 'po-attach-001',
        po_id: 'po-2025-001',
        file_name: '供應商報價單.pdf',
        file_path: '/attachments/po/2025/001/supplier_quote.pdf',
        uploaded_at: '2025-01-05T10:15:00',
        uploaded_by: '王採購'
      }
    ],
    history: [
      {
        id: 'po-hist-001',
        po_id: 'po-2025-001',
        action: 'created',
        action_by: '王採購',
        action_at: '2025-01-05T09:30:00',
        details: '根據MRP建議創建採購訂單'
      },
      {
        id: 'po-hist-002',
        po_id: 'po-2025-001',
        action: 'approved',
        action_by: '張經理',
        action_at: '2025-01-06T14:20:00',
        details: '核准採購訂單'
      }
    ]
  },
  {
    id: 'po-2025-002',
    po_number: 'PO-2025-002',
    supplier_id: 'sup-002',
    status: 'sent',
    created_at: '2025-01-10T11:15:00',
    created_by: '王採購',
    approved_at: '2025-01-11T09:45:00',
    approved_by: '張經理',
    sent_at: '2025-01-11T10:30:00',
    sent_by: '王採購',
    order_date: '2025-01-11',
    expected_delivery_date: '2025-01-25',
    payment_term_id: 'net30',
    shipping_method_id: 'express',
    shipping_address: '台北市信義區信義路五段7號',
    subtotal: 40000,
    tax: 2000,
    shipping_cost: 1200,
    total: 43200,
    currency: 'TWD',
    notes: '緊急採購，請供應商加急處理',
    mrp_plan_id: 'mrp-2025-q1',
    related_suggestion_ids: ['ps-002'],
    items: [
      {
        id: 'po-item-002',
        po_id: 'po-2025-002',
        product_id: 'prod-005',
        description: '組裝用螺絲 M5x10mm',
        quantity: 8000,
        unit: '個',
        unit_price: 5,
        subtotal: 40000,
        expected_delivery_date: '2025-01-25',
        received_quantity: 0,
        remaining_quantity: 8000
      }
    ],
    attachments: [],
    history: [
      {
        id: 'po-hist-003',
        po_id: 'po-2025-002',
        action: 'created',
        action_by: '王採購',
        action_at: '2025-01-10T11:15:00',
        details: '根據MRP建議創建採購訂單'
      },
      {
        id: 'po-hist-004',
        po_id: 'po-2025-002',
        action: 'approved',
        action_by: '張經理',
        action_at: '2025-01-11T09:45:00',
        details: '核准採購訂單'
      },
      {
        id: 'po-hist-005',
        po_id: 'po-2025-002',
        action: 'sent',
        action_by: '王採購',
        action_at: '2025-01-11T10:30:00',
        details: '發送採購訂單給供應商'
      }
    ]
  },
  {
    id: 'po-2025-003',
    po_number: 'PO-2025-003',
    supplier_id: 'sup-002',
    status: 'draft',
    created_at: '2025-01-15T14:30:00',
    created_by: '李採購',
    order_date: '2025-01-15',
    expected_delivery_date: '2025-02-05',
    payment_term_id: 'net45',
    shipping_method_id: 'standard',
    shipping_address: '台北市信義區信義路五段7號',
    subtotal: 20000,
    tax: 1000,
    shipping_cost: 500,
    total: 21500,
    currency: 'TWD',
    notes: '例行性採購',
    mrp_plan_id: 'mrp-2025-q1',
    related_suggestion_ids: ['ps-003'],
    items: [
      {
        id: 'po-item-003',
        po_id: 'po-2025-003',
        product_id: 'prod-008',
        description: '包裝盒 30x20x15cm',
        quantity: 4000,
        unit: '個',
        unit_price: 5,
        subtotal: 20000,
        expected_delivery_date: '2025-02-05',
        received_quantity: 0,
        remaining_quantity: 4000
      }
    ],
    attachments: [],
    history: [
      {
        id: 'po-hist-006',
        po_id: 'po-2025-003',
        action: 'created',
        action_by: '李採購',
        action_at: '2025-01-15T14:30:00',
        details: '根據MRP建議創建採購訂單'
      }
    ]
  },
  {
    id: 'po-2025-004',
    po_number: 'PO-2025-004',
    supplier_id: 'sup-003',
    status: 'partially_received',
    created_at: '2024-12-20T10:00:00',
    created_by: '王採購',
    approved_at: '2024-12-21T09:30:00',
    approved_by: '張經理',
    sent_at: '2024-12-21T11:15:00',
    sent_by: '王採購',
    order_date: '2024-12-21',
    expected_delivery_date: '2025-01-10',
    payment_term_id: 'net30',
    shipping_method_id: 'standard',
    shipping_address: '台北市信義區信義路五段7號',
    subtotal: 75000,
    tax: 3750,
    shipping_cost: 500,
    total: 79250,
    currency: 'TWD',
    notes: '年末採購',
    mrp_plan_id: 'mrp-2025-q1',
    related_suggestion_ids: [],
    items: [
      {
        id: 'po-item-004',
        po_id: 'po-2025-004',
        product_id: 'prod-002',
        description: '塑膠粒 B-grade',
        quantity: 3000,
        unit: '公斤',
        unit_price: 25,
        subtotal: 75000,
        expected_delivery_date: '2025-01-10',
        received_quantity: 1500,
        remaining_quantity: 1500,
        receipt_history: [
          {
            receipt_id: 'rcpt-001',
            receipt_date: '2025-01-05',
            quantity: 1500,
            received_by: '倉管李'
          }
        ]
      }
    ],
    attachments: [],
    history: [
      {
        id: 'po-hist-007',
        po_id: 'po-2025-004',
        action: 'created',
        action_by: '王採購',
        action_at: '2024-12-20T10:00:00',
        details: '創建採購訂單'
      },
      {
        id: 'po-hist-008',
        po_id: 'po-2025-004',
        action: 'approved',
        action_by: '張經理',
        action_at: '2024-12-21T09:30:00',
        details: '核准採購訂單'
      },
      {
        id: 'po-hist-009',
        po_id: 'po-2025-004',
        action: 'sent',
        action_by: '王採購',
        action_at: '2024-12-21T11:15:00',
        details: '發送採購訂單給供應商'
      },
      {
        id: 'po-hist-010',
        po_id: 'po-2025-004',
        action: 'partial_receipt',
        action_by: '倉管李',
        action_at: '2025-01-05T14:20:00',
        details: '部分收貨 1500 公斤'
      }
    ]
  },
  {
    id: 'po-2025-005',
    po_number: 'PO-2025-005',
    supplier_id: 'sup-005',
    status: 'received',
    created_at: '2024-12-15T09:45:00',
    created_by: '王採購',
    approved_at: '2024-12-16T10:30:00',
    approved_by: '張經理',
    sent_at: '2024-12-16T11:00:00',
    sent_by: '王採購',
    order_date: '2024-12-16',
    expected_delivery_date: '2024-12-30',
    actual_delivery_date: '2024-12-28',
    payment_term_id: 'net30',
    shipping_method_id: 'standard',
    shipping_address: '台北市信義區信義路五段7號',
    subtotal: 30000,
    tax: 1500,
    shipping_cost: 500,
    total: 32000,
    currency: 'TWD',
    notes: '年末採購',
    mrp_plan_id: 'mrp-2025-q1',
    related_suggestion_ids: [],
    items: [
      {
        id: 'po-item-005',
        po_id: 'po-2025-005',
        product_id: 'prod-006',
        description: '椅背外殼',
        quantity: 1000,
        unit: '個',
        unit_price: 30,
        subtotal: 30000,
        expected_delivery_date: '2024-12-30',
        actual_delivery_date: '2024-12-28',
        received_quantity: 1000,
        remaining_quantity: 0,
        receipt_history: [
          {
            receipt_id: 'rcpt-002',
            receipt_date: '2024-12-28',
            quantity: 1000,
            received_by: '倉管李'
          }
        ]
      }
    ],
    attachments: [],
    history: [
      {
        id: 'po-hist-011',
        po_id: 'po-2025-005',
        action: 'created',
        action_by: '王採購',
        action_at: '2024-12-15T09:45:00',
        details: '創建採購訂單'
      },
      {
        id: 'po-hist-012',
        po_id: 'po-2025-005',
        action: 'approved',
        action_by: '張經理',
        action_at: '2024-12-16T10:30:00',
        details: '核准採購訂單'
      },
      {
        id: 'po-hist-013',
        po_id: 'po-2025-005',
        action: 'sent',
        action_by: '王採購',
        action_at: '2024-12-16T11:00:00',
        details: '發送採購訂單給供應商'
      },
      {
        id: 'po-hist-014',
        po_id: 'po-2025-005',
        action: 'received',
        action_by: '倉管李',
        action_at: '2024-12-28T15:30:00',
        details: '完全收貨 1000 個'
      }
    ]
  }
];

// 採購收貨記錄
export const purchaseReceipts = [
  {
    id: 'rcpt-001',
    po_id: 'po-2025-004',
    po_item_id: 'po-item-004',
    receipt_number: 'RCPT-2025-001',
    receipt_date: '2025-01-05',
    received_by: '倉管李',
    quantity: 1500,
    quality_check: 'passed',
    notes: '貨品狀況良好',
    location: 'A-12-05',
    created_at: '2025-01-05T14:20:00'
  },
  {
    id: 'rcpt-002',
    po_id: 'po-2025-005',
    po_item_id: 'po-item-005',
    receipt_number: 'RCPT-2024-052',
    receipt_date: '2024-12-28',
    received_by: '倉管李',
    quantity: 1000,
    quality_check: 'passed',
    notes: '貨品狀況良好',
    location: 'B-05-12',
    created_at: '2024-12-28T15:30:00'
  }
];

// 供應商評價
export const supplierRatings = [
  {
    id: 'rating-001',
    supplier_id: 'sup-001',
    po_id: 'po-2025-001',
    rated_by: '王採購',
    rated_at: '2025-01-25',
    delivery_score: 4, // 1-5
    quality_score: 5, // 1-5
    price_score: 4, // 1-5
    service_score: 5, // 1-5
    overall_score: 4.5,
    comments: '供應商表現優良，交期準時，品質穩定'
  },
  {
    id: 'rating-002',
    supplier_id: 'sup-002',
    po_id: 'po-2025-002',
    rated_by: '王採購',
    rated_at: '2025-01-30',
    delivery_score: 5,
    quality_score: 4,
    price_score: 3,
    service_score: 4,
    overall_score: 4.0,
    comments: '交期非常準時，但價格稍高'
  },
  {
    id: 'rating-003',
    supplier_id: 'sup-003',
    po_id: 'po-2025-004',
    rated_by: '王採購',
    rated_at: '2025-01-15',
    delivery_score: 3,
    quality_score: 4,
    price_score: 5,
    service_score: 3,
    overall_score: 3.75,
    comments: '價格具競爭力，但交期略有延遲'
  },
  {
    id: 'rating-004',
    supplier_id: 'sup-005',
    po_id: 'po-2025-005',
    rated_by: '王採購',
    rated_at: '2025-01-05',
    delivery_score: 5,
    quality_score: 5,
    price_score: 4,
    service_score: 5,
    overall_score: 4.75,
    comments: '表現優異，提前交貨，品質極佳'
  }
];
